<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <h3>达人管理</h3>
      <div class="refresh">统计转化情况和财务结算使用</div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="三方平台">
          <el-select v-model="listQuery.platform" filterable placeholder="请选择三方平台">
            <el-option label="全部" value='' />
            <el-option v-for="item in platforms" :key="item.code" :label="item.name" :value='item.code' />
          </el-select>
        </el-form-item>
        <el-form-item label="达人ID">
          <el-input v-model="listQuery.authorId" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-form-item label="达人昵称">
          <el-input v-model="listQuery.authorName" placeholder="请输入" class="orderStyle" />
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <el-button v-if="judeRole" class="btnCreate exportExcel" type="primary" icon="el-icon-plus" @click="createThirdParty">添加达人</el-button>
      </el-form>
      <el-table v-loading="listLoading" :data="list" border fit highlight-current-row :header-cell-style="tableHeader">
        <el-table-column label="平台" align="center">
          <template slot-scope="{row}">
            <span>{{ getPlatformValue(row.platform) }}</span>
          </template>
        </el-table-column>
        <template>
          <el-table-column label="达人昵称" align="center">
            <template slot-scope="{row}">
              <span>{{ row.authorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="达人ID" align="center">
            <template slot-scope="{row}">
              <span>{{ row.authorId }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="生成时间">
          <template slot-scope="{row}">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row)" style="color:#FF9900;">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="添加达人" :visible.sync="thirdPartydialogVisible" width="605px" :before-close="cancelDialog">
        <el-form :model="editQuery" :rules="thirdPartyRules" label-width="110px" ref="thirdPartyRef">
          <el-form-item prop="platform" label="选择平台">
            <el-select v-model="editQuery.platform" filterable placeholder="请选择平台" class="selectWidth">
              <el-option
                v-for="item in platforms"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="authorName" label="达人昵称">
            <el-input v-model="editQuery.authorName" :disabled="isEdit" placeholder="请输入达人昵称" class="selectWidth" />
          </el-form-item>
          <el-form-item prop="authorId" label="达人ID">
            <el-input v-model="editQuery.authorId" :disabled="isEdit" placeholder="请输入达人ID" class="selectWidth" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog()">保 存</el-button>
        </span>
      </el-dialog>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import { getThirdPartyPromotionList, editProduct, addProduct } from "@/services/promotion";
import { getThirdPlatforms } from "@/services/order";
import PowerWrapper from "@/components/PowerWrapper";
import { delUndefined, timestampToDateTotal } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole } from '@/utils/auth'

// 本来达人管理和推广位共用index.vue文件，但是两个页面差别越来越大，需要用大量的if else区分场景
export default {
  name: "thirdPartyPromotion",
  components: {
    PowerWrapper
  },
  data() {
    return {
      CurrRole: "promotion",
      list: [],
      listQuery: {
        platform: null,
        authorId: null,
        authorName: null,
      },
      platforms: [],
      listLoading: false,
      thirdPartydialogVisible: false,
      editQuery: {
        platform: null,
        authorName: null,
        authorId: null,
      },
      thirdPartyRules: {
        platform: [
          { required: true, message: "请选择平台", trigger: ['blur', 'change'] },
        ],
        authorName: [
          { required: true, message: "请输入达人昵称", trigger: ['blur'] },
        ],
        authorId: [
          { required: true, message: "请输入达人ID", trigger: ['blur'] },
        ],
      },
      isEdit: false,
      editItem: null,
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    },
    judeRole() {
      return getTeamRole() && (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2)
    },
  },
  created() {
    // 列表查询
    this.getList()
    this.getThirdPlatforms();
  },
  methods: {
    getPlatformValue(key) {
      if (!key) return '--';
      const platform = this.platforms.find(item => item.code === key);
      return platform?.name;
    },
    async getThirdPlatforms() {
      try {
        const res = await getThirdPlatforms();
        const { errCode, errMsg, data } = res.data;
        if (errCode === 0) {
          this.platforms = data;
        } else {
          this.$message({ type: 'error', message: errMsg })
        }
      } catch (error) {
        this.$message({ type: 'error', message: '三方平台获取失败！请稍后重试' })
      }
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    getList(btnName) {
      this.listLoading = true;
      const params = {
        teamCode: getTeamCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        ...this.listQuery
      }
      getThirdPartyPromotionList(delUndefined(params)).then(res => {
        console.log('Promotion list ', res);
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.listLoading = false;
          const orderList = res.data.data;
          this.list = orderList;
          if (btnName === 'search') {
            this.listQuery.current = 1;
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false;
          this.list = [];
        }
      });
    },

    handleSearch() {
      this.getList('search');
    },
    createThirdParty() {
      this.isEdit = false;
      this.editQuery = {
        platform: null,
        authorName: null,
        authorId: null,
      };
      this.thirdPartydialogVisible = true;
      if (this.$refs.thirdPartyRef) this.$refs.thirdPartyRef.resetFields();
    },
    edit(row) {
      const { platform, authorId, authorName } = row;
      this.editItem = row;
      this.isEdit = true;
      this.editQuery = {
        platform,
        authorName,
        authorId,
      };
      this.thirdPartydialogVisible = true;
    },
    cancelDialog() {
      this.thirdPartydialogVisible = false;
    },
    confirmDialog() {
      const { editQuery, isEdit, editItem } = this
      const typeTxt = '';
      this.$refs.thirdPartyRef.validate(async (valid) => {
        if (valid) {
          const { name, authorName, authorId, platform } = editQuery
          const params = {
            platform,
            authorName,
            authorId,
            name,
            teamCode: getTeamCode(),
            createAgentCode: getAgentCode()
          }
          if (isEdit) { // 编辑
            editProduct({
              type: 'PUT',
              params: {
                ...editItem,
                ...editQuery
              }
            }).then(res => {
              if (res.data && res.data.errCode === 0) {
                this.$message({ type: 'success', message: `编辑${typeTxt}成功` })
                this.getList();
                this.cancelDialog();
              } else if (res.data && res.data.errCode === 1016) {
                this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
                Cookie.remove('staffToken')
                setTimeout(() => {
                  this.$router.push({ path: '/login' })
                }, 3000)
              } else {
                this.$message({ type: 'error', message: res.data.errMsg })
              }
            })
          } else {
            addProduct({
              type: 'POST',
              params: {
                ...delUndefined(params)
              }
            }).then(res => {
              if (res.data && res.data.errCode === 0) {
                this.$message({ type: 'success', message: `创建${typeTxt}成功` })
                this.getList();
                this.cancelDialog();
              } else if (res.data && res.data.errCode === 1016) {
                this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
                Cookie.remove('staffToken')
                setTimeout(() => {
                  this.$router.push({ path: '/login' })
                }, 3000)
              } else {
                this.$message({ type: 'error', message: res.data.errMsg })
              }
            })
          }
        } else {
          this.$message({ type: 'error', message: "请完整填写信息" })
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../styles/common.less';
.exportExcel {
  float: right;
  margin-bottom: 10px;
}
.distributorList {
  position: relative;
  .btnsStyle{
    display: inline-block;
    margin-left: 20px;
    color:#FF9900;
  }
  .selectWidth{
    width: 300px;
  }
  .colorStyle{
    display: inline-block;
    color:#FF9900;
  }
  .inputWidth{
    width: 380px;
  }
  .blue{
    color:#409EFF;
  }
  .channelRow{
    position: relative;
  }
  .cellStyle{
    .channelCell{
      display: inline-block;
      width: 100%;
      cursor: pointer;
      .iconEdit{
        width: 10%;
        position: absolute;
        margin-top: 2px;
        right: 10px;
        font-size: 20px;
        display: inline-block;
      }
    }
  }
}
</style>
